import classNames from "classnames";
import React, { useEffect } from "react";
import * as Ons from "react-onsenui";
import useSessionStorage from "../../hooks/useSessionStorage";
import { STRINGS } from "../../strings";
import { getLanguage, langMap, translate } from "../../translate";
import { PLAY_ICON } from "../../utils/svgs_new";
import { AppButton } from "../Generic/AppButton";
import { AppDimmer } from "../Generic/AppDimmer";
import { AppIcon } from "../Generic/AppIcon";
import { AppOverlay } from "../Generic/AppOverlay";
import AppSlideFadeIn from "../Generic/AppSlideFadeIn";
import { IsDefined } from "../Generic/IsDefined";
import MedFlytPassportLogo from "../MedFlytPassportLogo";
import PopupVideo from "../PopupVideo";

interface PassportVideoProps {
  onClickPassport: (dontShowAgain: boolean) => void;
}

const PassportVideo = (props: PassportVideoProps) => {
  const [isPlaying, setPlaying] = React.useState<boolean>(false);
  const [dontShowAgain, setDontShowAgain] = React.useState(false);
  const [video, setVideo] = React.useState<{ url: string; thumbnailUrl: string }>();
  const [playedSeconds, setPlayedSeconds] = useSessionStorage("passport-video-seconds", 0);

  const handleChangeDontShowAgain = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDontShowAgain(event.target.checked);
  };

  const contentElem = (
    <div
      className={classNames("__content-wrapper", {
        active: !isPlaying,
      })}
    >
      <div className="__content">
        <AppSlideFadeIn delay={300}>
          <h4>{translate(STRINGS.INTRODUCING)}</h4>
        </AppSlideFadeIn>
        <AppSlideFadeIn delay={450}>
          <MedFlytPassportLogo />
        </AppSlideFadeIn>
        <div className="__buttons">
          <AppSlideFadeIn delay={600}>
            <AppButton onClick={() => setPlaying(true)}>
              <AppIcon icon={PLAY_ICON} size={12} />
              <span>{translate(STRINGS.WATCH_HOW_IT_WORKS)}</span>
            </AppButton>
          </AppSlideFadeIn>
          <AppSlideFadeIn delay={700}>
            <span className="__divider">{translate(STRINGS.OR)}</span>
          </AppSlideFadeIn>
          <AppSlideFadeIn delay={800}>
            <AppButton
              color="white"
              onClick={() => props.onClickPassport.call(null, dontShowAgain)}
            >
              {translate(STRINGS.GO_TO_MEDFLYT_PASSPORT)}
            </AppButton>
          </AppSlideFadeIn>
          <AppSlideFadeIn delay={900}>
            <label className="__checkbox">
              <Ons.Checkbox onChange={handleChangeDontShowAgain} checked={dontShowAgain} />
              <span>{translate(STRINGS.DONT_SHOW_AGAIN)}</span>
            </label>
          </AppSlideFadeIn>
        </div>
      </div>
    </div>
  );

  const handleResolveLanguage = (language: string) => {
    const selectedLanguage = langMap[language];
    let url = "https://orientation-center-prod.s3.amazonaws.com/passport/hls/$lang/video.m3u8";
    const thumbnail = "https://orientation-center-prod.s3.amazonaws.com/passport/preview.jpg";

    switch (selectedLanguage) {
      case langMap.en:
      case langMap.es:
      case langMap.ru:
      case langMap.zh: {
        url = url.replace("$lang", selectedLanguage.toLocaleLowerCase());
        break;
      }
      default: {
        url = url.replace("$lang", langMap.en.toLocaleLowerCase());
      }
    }
    setVideo({
      url: url,
      thumbnailUrl: thumbnail,
    });
  };

  useEffect(() => {
    getLanguage().then(handleResolveLanguage);
  }, []);

  return (
    <AppOverlay className="PassportVideo">
      <div className="__wrapper">
        <IsDefined value={video}>
          {(definedVideo) => (
            <PopupVideo
              isPlaying={isPlaying}
              thumbnailUrl={definedVideo.thumbnailUrl}
              playedSeconds={playedSeconds}
              url={definedVideo.url}
              onSetPlayedSeconds={setPlayedSeconds}
              onSetPlaying={setPlaying}
            />
          )}
        </IsDefined>
        {contentElem}
      </div>
      <AppDimmer />
    </AppOverlay>
  );
};

export default PassportVideo;
